import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-kling-color-large.tsx
/**
* icon.24.logo.kling.color.large
*
* ![](data:image/svg+xml;base64,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)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11695
*/
const Icon24LogoKlingColorLarge = memo(function Icon24LogoKlingColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	const idc = `${id}2`;
	const idd = `${id}3`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "M7.06 13.35c.38-1.163.882-2.283 1.498-3.34 2.377-4.12 5.846-6.568 7.747-5.471-4.276-2.469-9.856-.811-12.463 3.703a10 10 0 0 0-.778 1.692c-.194.555.07 1.15.578 1.445z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "M16.941 10.64a17.4 17.4 0 0 1-1.5 3.342c-2.377 4.119-5.845 6.568-7.746 5.47 4.277 2.47 9.856.811 12.463-3.703q.468-.81.778-1.692c.194-.553-.069-1.15-.577-1.443z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idc})`,
				d: "M15.442 13.988c2.378-4.119 2.765-8.347.863-9.445-1.9-1.097-5.368 1.353-7.747 5.47 1.555-2.692 4.356-3.986 6.257-2.888s2.181 4.17.627 6.863"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idd})`,
				d: "M8.558 10.012c-2.378 4.119-2.765 8.347-.863 9.444 1.9 1.098 5.37-1.351 7.747-5.47-1.555 2.693-4.356 3.987-6.257 2.889s-2.181-4.17-.627-6.863"
			}),
			/* @__PURE__ */ jsxs("defs", { children: [
				/* @__PURE__ */ jsxs("radialGradient", {
					id: ida,
					cx: "0",
					cy: "0",
					r: "1",
					gradientTransform: "rotate(-59.132 15.116 .56)scale(10.9306 14.979)",
					gradientUnits: "userSpaceOnUse",
					children: [
						/* @__PURE__ */ jsx("stop", {
							offset: ".095",
							stopColor: "#FFF959"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".326",
							stopColor: "#0DF35E"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".64",
							stopColor: "#0BF2F9"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: "1",
							stopColor: "#04A6F0"
						})
					]
				}),
				/* @__PURE__ */ jsxs("radialGradient", {
					id: idb,
					cx: "0",
					cy: "0",
					r: "1",
					gradientTransform: "matrix(-5.60807 9.3823 -12.85725 -7.68515 17.12 10.744)",
					gradientUnits: "userSpaceOnUse",
					children: [
						/* @__PURE__ */ jsx("stop", {
							offset: ".095",
							stopColor: "#FFF959"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".326",
							stopColor: "#0DF35E"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".64",
							stopColor: "#0BF2F9"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: "1",
							stopColor: "#04A6F0"
						})
					]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idc,
					x1: "14.683",
					x2: "16.546",
					y1: "4.372",
					y2: "10.419",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#003EFF" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#0BFFE7"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idd,
					x1: "9.317",
					x2: "7.454",
					y1: "19.628",
					y2: "13.581",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#003EFF" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#0BFFE7"
					})]
				})
			] })
		]
	});
});
//#endregion
export { Icon24LogoKlingColorLarge };

//# sourceMappingURL=icon-24-logo-kling-color-large.js.map